"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PointLocator = _interopRequireDefault(require("../../algorithm/PointLocator"));

var _PolygonExtracter = _interopRequireDefault(require("../../geom/util/PolygonExtracter"));

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _LineString = _interopRequireDefault(require("../../geom/LineString"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _Point = _interopRequireDefault(require("../../geom/Point"));

var _Polygon = _interopRequireDefault(require("../../geom/Polygon"));

var _GeometryLocation = _interopRequireDefault(require("./GeometryLocation"));

var _Double = _interopRequireDefault(require("../../../../../java/lang/Double"));

var _PointExtracter = _interopRequireDefault(require("../../geom/util/PointExtracter"));

var _ConnectedElementLocationFilter = _interopRequireDefault(require("./ConnectedElementLocationFilter"));

var _LineSegment = _interopRequireDefault(require("../../geom/LineSegment"));

var _LinearComponentExtracter = _interopRequireDefault(require("../../geom/util/LinearComponentExtracter"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

var _Distance = _interopRequireDefault(require("../../algorithm/Distance"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DistanceOp =
/*#__PURE__*/
function () {
  function DistanceOp() {
    _classCallCheck(this, DistanceOp);

    DistanceOp.constructor_.apply(this, arguments);
  }

  _createClass(DistanceOp, [{
    key: "computeContainmentDistance",
    value: function computeContainmentDistance() {
      if (arguments.length === 0) {
        var locPtPoly = new Array(2).fill(null);
        this.computeContainmentDistance(0, locPtPoly);
        if (this._minDistance <= this._terminateDistance) return null;
        this.computeContainmentDistance(1, locPtPoly);
      } else if (arguments.length === 2) {
        var polyGeomIndex = arguments[0],
            _locPtPoly = arguments[1];
        var polyGeom = this._geom[polyGeomIndex];
        if (polyGeom.getDimension() < 2) return null;
        var locationsIndex = 1 - polyGeomIndex;

        var polys = _PolygonExtracter.default.getPolygons(polyGeom);

        if (polys.size() > 0) {
          var insideLocs = _ConnectedElementLocationFilter.default.getLocations(this._geom[locationsIndex]);

          this.computeContainmentDistance(insideLocs, polys, _locPtPoly);

          if (this._minDistance <= this._terminateDistance) {
            this._minDistanceLocation[locationsIndex] = _locPtPoly[0];
            this._minDistanceLocation[polyGeomIndex] = _locPtPoly[1];
            return null;
          }
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && (0, _hasInterface.default)(arguments[0], _List.default) && (0, _hasInterface.default)(arguments[1], _List.default)) {
          var locs = arguments[0],
              _polys = arguments[1],
              _locPtPoly2 = arguments[2];

          for (var i = 0; i < locs.size(); i++) {
            var loc = locs.get(i);

            for (var j = 0; j < _polys.size(); j++) {
              this.computeContainmentDistance(loc, _polys.get(j), _locPtPoly2);
              if (this._minDistance <= this._terminateDistance) return null;
            }
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof _GeometryLocation.default && arguments[1] instanceof _Polygon.default) {
          var ptLoc = arguments[0],
              poly = arguments[1],
              _locPtPoly3 = arguments[2];
          var pt = ptLoc.getCoordinate();

          if (_Location.default.EXTERIOR !== this._ptLocator.locate(pt, poly)) {
            this._minDistance = 0.0;
            _locPtPoly3[0] = ptLoc;
            _locPtPoly3[1] = new _GeometryLocation.default(poly, pt);
            ;
            return null;
          }
        }
      }
    }
  }, {
    key: "computeMinDistanceLinesPoints",
    value: function computeMinDistanceLinesPoints(lines, points, locGeom) {
      for (var i = 0; i < lines.size(); i++) {
        var line = lines.get(i);

        for (var j = 0; j < points.size(); j++) {
          var pt = points.get(j);
          this.computeMinDistance(line, pt, locGeom);
          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }, {
    key: "computeFacetDistance",
    value: function computeFacetDistance() {
      var locGeom = new Array(2).fill(null);

      var lines0 = _LinearComponentExtracter.default.getLines(this._geom[0]);

      var lines1 = _LinearComponentExtracter.default.getLines(this._geom[1]);

      var pts0 = _PointExtracter.default.getPoints(this._geom[0]);

      var pts1 = _PointExtracter.default.getPoints(this._geom[1]);

      this.computeMinDistanceLines(lines0, lines1, locGeom);
      this.updateMinDistance(locGeom, false);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistanceLinesPoints(lines0, pts1, locGeom);
      this.updateMinDistance(locGeom, false);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistanceLinesPoints(lines1, pts0, locGeom);
      this.updateMinDistance(locGeom, true);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistancePoints(pts0, pts1, locGeom);
      this.updateMinDistance(locGeom, false);
    }
  }, {
    key: "nearestLocations",
    value: function nearestLocations() {
      this.computeMinDistance();
      return this._minDistanceLocation;
    }
  }, {
    key: "updateMinDistance",
    value: function updateMinDistance(locGeom, flip) {
      if (locGeom[0] === null) return null;

      if (flip) {
        this._minDistanceLocation[0] = locGeom[1];
        this._minDistanceLocation[1] = locGeom[0];
      } else {
        this._minDistanceLocation[0] = locGeom[0];
        this._minDistanceLocation[1] = locGeom[1];
      }
    }
  }, {
    key: "nearestPoints",
    value: function nearestPoints() {
      this.computeMinDistance();
      var nearestPts = [this._minDistanceLocation[0].getCoordinate(), this._minDistanceLocation[1].getCoordinate()];
      return nearestPts;
    }
  }, {
    key: "computeMinDistance",
    value: function computeMinDistance() {
      if (arguments.length === 0) {
        if (this._minDistanceLocation !== null) return null;
        this._minDistanceLocation = new Array(2).fill(null);
        this.computeContainmentDistance();
        if (this._minDistance <= this._terminateDistance) return null;
        this.computeFacetDistance();
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && arguments[0] instanceof _LineString.default && arguments[1] instanceof _Point.default) {
          var line = arguments[0],
              pt = arguments[1],
              locGeom = arguments[2];
          if (line.getEnvelopeInternal().distance(pt.getEnvelopeInternal()) > this._minDistance) return null;
          var coord0 = line.getCoordinates();
          var coord = pt.getCoordinate();

          for (var i = 0; i < coord0.length - 1; i++) {
            var dist = _Distance.default.pointToSegment(coord, coord0[i], coord0[i + 1]);

            if (dist < this._minDistance) {
              this._minDistance = dist;
              var seg = new _LineSegment.default(coord0[i], coord0[i + 1]);
              var segClosestPoint = seg.closestPoint(coord);
              locGeom[0] = new _GeometryLocation.default(line, i, segClosestPoint);
              locGeom[1] = new _GeometryLocation.default(pt, 0, coord);
            }

            if (this._minDistance <= this._terminateDistance) return null;
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof _LineString.default && arguments[1] instanceof _LineString.default) {
          var line0 = arguments[0],
              line1 = arguments[1],
              _locGeom = arguments[2];
          if (line0.getEnvelopeInternal().distance(line1.getEnvelopeInternal()) > this._minDistance) return null;
          var coord0 = line0.getCoordinates();
          var coord1 = line1.getCoordinates();

          for (var i = 0; i < coord0.length - 1; i++) {
            for (var j = 0; j < coord1.length - 1; j++) {
              var dist = _Distance.default.segmentToSegment(coord0[i], coord0[i + 1], coord1[j], coord1[j + 1]);

              if (dist < this._minDistance) {
                this._minDistance = dist;
                var seg0 = new _LineSegment.default(coord0[i], coord0[i + 1]);
                var seg1 = new _LineSegment.default(coord1[j], coord1[j + 1]);
                var closestPt = seg0.closestPoints(seg1);
                _locGeom[0] = new _GeometryLocation.default(line0, i, closestPt[0]);
                _locGeom[1] = new _GeometryLocation.default(line1, j, closestPt[1]);
              }

              if (this._minDistance <= this._terminateDistance) return null;
            }
          }
        }
      }
    }
  }, {
    key: "computeMinDistancePoints",
    value: function computeMinDistancePoints(points0, points1, locGeom) {
      for (var i = 0; i < points0.size(); i++) {
        var pt0 = points0.get(i);

        for (var j = 0; j < points1.size(); j++) {
          var pt1 = points1.get(j);
          var dist = pt0.getCoordinate().distance(pt1.getCoordinate());

          if (dist < this._minDistance) {
            this._minDistance = dist;
            locGeom[0] = new _GeometryLocation.default(pt0, 0, pt0.getCoordinate());
            locGeom[1] = new _GeometryLocation.default(pt1, 0, pt1.getCoordinate());
          }

          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }, {
    key: "distance",
    value: function distance() {
      if (this._geom[0] === null || this._geom[1] === null) throw new _IllegalArgumentException.default("null geometries are not supported");
      if (this._geom[0].isEmpty() || this._geom[1].isEmpty()) return 0.0;
      this.computeMinDistance();
      return this._minDistance;
    }
  }, {
    key: "computeMinDistanceLines",
    value: function computeMinDistanceLines(lines0, lines1, locGeom) {
      for (var i = 0; i < lines0.size(); i++) {
        var line0 = lines0.get(i);

        for (var j = 0; j < lines1.size(); j++) {
          var line1 = lines1.get(j);
          this.computeMinDistance(line0, line1, locGeom);
          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DistanceOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "distance",
    value: function distance(g0, g1) {
      var distOp = new DistanceOp(g0, g1);
      return distOp.distance();
    }
  }, {
    key: "isWithinDistance",
    value: function isWithinDistance(g0, g1, distance) {
      var envDist = g0.getEnvelopeInternal().distance(g1.getEnvelopeInternal());
      if (envDist > distance) return false;
      var distOp = new DistanceOp(g0, g1, distance);
      return distOp.distance() <= distance;
    }
  }, {
    key: "nearestPoints",
    value: function nearestPoints(g0, g1) {
      var distOp = new DistanceOp(g0, g1);
      return distOp.nearestPoints();
    }
  }]);

  return DistanceOp;
}();

exports.default = DistanceOp;

DistanceOp.constructor_ = function () {
  this._geom = null;
  this._terminateDistance = 0.0;
  this._ptLocator = new _PointLocator.default();
  this._minDistanceLocation = null;
  this._minDistance = _Double.default.MAX_VALUE;

  if (arguments.length === 2) {
    var g0 = arguments[0],
        g1 = arguments[1];
    DistanceOp.constructor_.call(this, g0, g1, 0.0);
  } else if (arguments.length === 3) {
    var _g = arguments[0],
        _g2 = arguments[1],
        terminateDistance = arguments[2];
    this._geom = new Array(2).fill(null);
    this._geom[0] = _g;
    this._geom[1] = _g2;
    this._terminateDistance = terminateDistance;
  }
};